import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SHOPSMALLHEROBLOCK_LEGACY_FIELD_ORDER = [
  "display_heading",
  "display_category",
  "display_description",
  "title_size",
  "background_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  shopSmallHeroBlockDescriptor: _generatedShopSmallHeroBlockDescriptor,
  shopSmallHeroBlockBlocDefinition,
  shopSmallHeroBlockDashboardLayout,
  shopSmallHeroBlockConfig,
  shopSmallHeroBlockResolveConfig,
  shopSmallHeroBlockProperties,
} = doodBlockConfig(
  {
    name: "Shop - Small Hero",
    componentType: 'ShopSmallHeroBlockComponent',
    category: 'catalog',
    description: "Shop - Small Hero.",
    keywords: [],
    allowed_in: ["ShopPage"],
    sharedFields: {}
  },

  () => ({
    display_heading: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.shop-small-hero.display-heading.label",
      }
    }),
    display_category: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.shop-small-hero.display-category.label",
        help: "pages.blocks.shop-small-hero.display-category.help",
      }
    }),
    display_description: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.shop-small-hero.display-description.label",
      }
    }),
    title_size: propertyValue({
      type: 'select',
      value: "M",
      options: {
        label: "pages.blocks.shop-small-hero.title-size.label",
        choices: [
          {
            value: "XS",
            label: "pages.blocks.shop-small-hero.title-size.options.XS",
          },
          {
            value: "S",
            label: "pages.blocks.shop-small-hero.title-size.options.S",
          },
          {
            value: "M",
            label: "pages.blocks.shop-small-hero.title-size.options.M",
          },
          {
            value: "L",
            label: "pages.blocks.shop-small-hero.title-size.options.L",
          }
        ]
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"transparent"},
      options: {
        label: "pages.blocks.shop-small-hero.background-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.shop-small-hero.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.shop-small-hero.fieldset.title.label",
            fields: [
              "display_heading",
              { prop: "title_size", visibleWhen: { display_heading: true } },
            ],
          },
          {
            legend: "pages.blocks.shop-small-hero.fieldset.category.label",
            fields: ["display_category"],
          },
          {
            legend: "pages.blocks.shop-small-hero.fieldset.description.label",
            fields: ["display_description"],
          },
          {
            legend: "pages.blocks.shop-small-hero.fieldset.background.label",
            fields: ["background_color"],
          },
        ],
      },
    ],
  })
);

export function shopSmallHeroBlockDescriptor(): IBlockDescriptor;
export function shopSmallHeroBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function shopSmallHeroBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedShopSmallHeroBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedShopSmallHeroBlockDescriptor, shopSmallHeroBlockProperties, fieldOrder);
}

export {
  shopSmallHeroBlockBlocDefinition,
  shopSmallHeroBlockDashboardLayout,
  shopSmallHeroBlockProperties,
  shopSmallHeroBlockConfig,
  shopSmallHeroBlockResolveConfig,
};

export type ShopSmallHeroBlockConfig = typeof shopSmallHeroBlockConfig;
